import { Browser } from '@capacitor/browser';
import { istNativeApp } from './nativePlatform';

/**
 * Fremde Adresse außerhalb der Anwendung öffnen (docs/android-app-plan.md, P3).
 *
 * Browser: neuer Tab, SYNCHRON im Aufruf — kein `await` davor, sonst greift
 * der Popup-Blocker (die Klick-Geste gilt nur im selben Durchlauf).
 *
 * App: im System-Browser (Custom Tab) über `Browser.open`, ohne darauf zu
 * warten. `window.open` ist in der Hülle nur der Notweg, falls das Plugin
 * scheitert (z. B. ältere APK): die WebView öffnet keine Tabs, sie lädt die
 * Adresse selbst, und erst Capacitor fängt die fremde Adresse ab und reicht
 * sie an Android weiter (Gerätetest P10).
 */
export function externOeffnen(url: string): void {
  if (istNativeApp()) {
    Browser.open({ url }).catch((e: unknown) => {
      console.error('[externOeffnen] System-Browser nicht erreichbar, weiche auf window.open aus:', e);
      window.open(url, '_blank', 'noopener,noreferrer');
    });
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}
